import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Youtube from './Youtube';
import 'bootstrap/dist/css/bootstrap.min.css';
import './About.css';

export default class extends React.Component {
	state = {
    didViewCountUp: false
  };


  onVisibilityChange = isVisible => {
    if (isVisible) {
      this.setState({didViewCountUp: true});
    }
  }
  render() {
    return (
      <Container>
	    {/*<div className="project-about">
            <img className="loga-about" src="loga_gotowe.jpg" alt="loga" />
            <p>
               Projekt polega na praktycznym wdrożeniu nowej technologii w postaci wyników prac B+R drogą inwestycji technologicznej
               polegającej na uruchomieniu produkcji opakowań ekologicznych dla rynku fresh food.
            </p>
            <p>
               Celem przedsięwzięcia jest trwała poprawa konkurencyjności przedsiębiorstwa HADEPOL FLEXO Sp. z o.o. na krajowym
               i zagranicznym rynku opakowań poprzez wdrożenie innowacji technologicznych w obszarze wytwarzania opakowań papierowych powlekanych.
               Efektem realizacji projektu będzie wdrożenie innowacji procesowej nie znanej do tej pory na świecie oraz zupełnie nowego produktu
               o nieznanym dotąd poziomie użytkowym. Zakres rzeczowy projektu obejmuje nakłady inwestycyjne związane
               z zakupem następujących nowych środków trwałych:
               1. Linia technologiczna do produkcji opakowań.
            </p>
            <p>
               Projekt pozwoli znacząco poszerzyć ofertę produktową i technologiczną przedsiębiorstwa, co zostanie osiągnięte drogą
               praktycznego zastosowania innowacyjnych rozwiązań w zakresie produkcji opakowań papierowych o unikalnej konstrukcji
               i podwyższonych walorach użytkowych.Projekt polega na praktycznym wdrożeniu nowej technologii w postaci wyników prac B+R drogą
               inwestycji technologicznej polegającej na uruchomieniu produkcji opakowań ekologicznych dla rynku fresh food."
            </p>
            <p>
               Wartość projektu : 10 380 499,20 PLN<br />
               Wkład Funduszy Europejskich : 4 671 224,66 PLN
            </p>
          </div>*/}
		<Row>
			<Col className="center title">
				<h2>O nas</h2>
			</Col>
		</Row>
	     <Row>
		    <Col xs={12} md={6} className="center">
		    	<h4>Nasza firma to ludzie którzy ją tworzą</h4>
		    	<p className="about">	    	
		    		Hadepol FLEXO Sp. z o.o. to zgrany zespół pracowników różnych specjalności, o wysokich kwalifikacjach, motywacji i zaangażowaniu. Skupiając się na doświadczeniu oraz długofalowej współpracy nie zapominamy także o innowacjach, nowatorskich rozwiązaniach i nieustannym rozwoju. Oferując coraz lepsze warunki pracy poprzez efektywne dokształcanie kadry pracowniczej oraz nieustanne unowocześnianie i automatyzację produkcji, zwiększamy tym samym poziom realizacji usług. Aby należycie spełnić wymagania Klientów w zakresie jakości dostarczanych im produktów, firma z dużą uwagą podchodzi do jakości surowców i dodatków, skrupulatnie dobierając i stale monitorując swoich poddostawców, którzy w większości zaliczają się do światowej czołówki w przemyśle chemicznym.
		    	</p>
		    	<h4>Klienci – największy kapitał naszej firmy</h4>
		    	<p className="about">	    	
		    		Jesteśmy firmą przyjazną, wychodzącą naprzeciw najbardziej wyszukanym oczekiwaniom Klientów. W celu dopasowania się do ciągle zmieniających się potrzeb, przeprowadzamy szereg badań mających na celu uzyskanie jak najwyższej satysfakcji z naszych usług. Zaufanie i lojalność naszych klientów jest dla nas sprawą priorytetową, gdyż to Państwo stanowicie największy kapitał naszej firmy.
		    	</p>
		    </Col>
		    <Col xs={12} md={6} className="center">
		    	<Youtube />
		    	<span className="red description-movie">
		    		Dążymy do tego, aby osiągnąć najwyższą pozycję na rynku, ale to dzięki naszym Klientom cel ten jest możliwy do zrealizowania.
		    	</span>
		    	<span className="block">
		    		W celu poszerzenia oferowanego asortymentu bezustannie podnosimy kwalifikacje naszych pracowników oraz inwestujemy w bazę technologiczną firmy. Zadowolenie klienta jest dla nas największą satysfakcją.
		    	</span>
		    </Col>
	  	 </Row>
	  		
	</Container>
    );
  }
}